import { ApolloLink, Observable } from "@apollo/client"

interface ValidateAuthTokenMiddlewareArgs {
  getAuthToken: () => Promise<string>
  logOut: () => Promise<void>
}

/**
 * Check if the current user has a valid JWT, otherwise log them out gracefully
 */
export const validateAuthToken = ({ getAuthToken, logOut }: ValidateAuthTokenMiddlewareArgs) =>
  new ApolloLink((operation, forward) => {
    return new Observable((observer) => {
      getAuthToken()
        .then((hasToken) => {
          if (!hasToken) {
            void logOut()
            observer.complete()
          } else {
            const handle = forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer),
            })

            return () => {
              if (handle) handle.unsubscribe()
            }
          }
        })
        .catch((error) => {
          observer.error(error)
          observer.complete()
        })
    })
  })
